import { Avatar } from 'components/shared/avatar'
import React from 'react'
import { useSelector } from 'react-redux'
import { getCurrentHandle } from 'reduxes/slices/current/selectors'

import { css } from 'design'
import { Stack } from 'primitives/containers'

import { useHandleMetadata } from '../../hooks/use_handle_metadata'

export type MainMenuContentProps = {
  isOpen?: boolean
  showAvatar?: boolean
} & React.ComponentProps<typeof Stack> &
  React.HTMLAttributes<HTMLDivElement>

export const MainMenuContent = ({
  isOpen,
  showAvatar,
  ...props
}: MainMenuContentProps) => {
  const currentHandle = useSelector(getCurrentHandle)
  const { name } = useHandleMetadata(currentHandle)

  return (
    <Stack
      direction="row"
      gap={showAvatar ? '3' : '0'}
      {...props}
      css={{ width: '100%' }}
    >
      {showAvatar && <Avatar handle={currentHandle} />}
      <Stack css={{ padding: showAvatar ? '0' : '0 $2' }}>
        {name ? (
          <>
            <div className="topic__menu__header__dropdown__primary">
              <span className={nameStyles()}>{name}</span>
              {isOpen ? (
                <i className="fas fa-caret-down" />
              ) : (
                <i className="fas fa-caret-right" />
              )}
            </div>
            <div className="topic__menu__header__dropdown__secondary">
              {currentHandle}
            </div>
          </>
        ) : (
          <div className="topic__menu__header__dropdown__primary">
            <span>{currentHandle}</span>

            {isOpen ? (
              <i className="fas fa-caret-down" />
            ) : (
              <i className="fas fa-caret-right" />
            )}
          </div>
        )}
      </Stack>
    </Stack>
  )
}

const nameStyles = css({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  paddingRight: '$2',
})
